
import dayjs from "dayjs";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import { addCurrencyUnit, addCurrencySymbol } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";

const finance = namespace("finance");
const base = namespace("base");
const setting = namespace("setting");

@Component({})
@Table("loadListData")
export default class PaymentOrder extends Vue {
  @finance.Action getPaymentList;
  @base.Action getDictionaryList;
  @setting.Action getPatternPaymentList;
  dayjs = dayjs;
  addCurrencyUnit = addCurrencyUnit;
  splitThousands = splitThousands;
  addCurrencySymbol = addCurrencySymbol;
  emptyToLine = emptyToLine;
  searchForm = {
    paymentNo: "",
    paidTimeFrom: "",
    paidTimeTo: "",
    paymentTimeFrom: "",
    paymentTimeTo: "",
    payeeName: "",
    paymentType: "",
    paidMethod: ""
  };
  paymentList: any[] = [];
  paymentTypeList: any[] = [];
  get searchList() {
    return [
      {
        label: t("finance.payment-time"),
        type: "timerange",
        value: "",
        prop: "paidTime"
      },
      {
        label: t("finance.creation-time"),
        type: "timerange",
        value: "",
        prop: "paymentTime"
      },
      {
        label: t("finance.payment-no"),
        type: "input",
        value: "",
        prop: "paymentNo"
      },
      {
        label: t("finance.payee"),
        type: "input",
        value: "",
        prop: "payeeName"
      },
      {
        label: t("finance.type-payment"),
        type: "select",
        selectList: this.paymentTypeList,
        value: "",
        prop: "paymentType"
      },
      {
        label: t("finance.payment-way"),
        type: "select",
        selectList: this.receiptPaymentTypeList,
        value: "",
        prop: "paidMethod"
      }
    ];
  }

  created() {
    this.init();
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "paymentTime" || item.prop === "paidTime") {
          this.searchForm[item.prop + "From"] = item.value ? item.value[0] : "";
          this.searchForm[item.prop + "To"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  totalPaidAmount: string = "";
  @Table.LoadDataMethod()
  loadListData() {
    return this.getPaymentList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.totalPaidAmount = this.$safeValue(data, "data.totalPaidAmount");
      this.paymentList = this.$safeValue(data, "data.list");
      return data;
    });
  }

  handleLinkView(row) {
    window.open(this.$router.resolve(`/finance/payment-order-view/${row.paymentNo}`).href);
  }
  async init() {
    this.loadListData();
    this.getDictionaryList("payment_type").then(data => {
      this.paymentTypeList = data;
    });
    await this.getReceiptPaymentTypeList();
  }
  receiptPaymentTypeList = [];
  /**
   * 获取查询条件-收款方式list
   */
  async getReceiptPaymentTypeList() {
    this.getPatternPaymentList({
      status: 1,
      includeDebitCard: "1"
    }).then(data => {
      let list = this.$safeValue(data, "data", []);
      this.receiptPaymentTypeList = list.map(item => {
        return Object.assign(item, {
          label: item.payMethodName,
          value: item.payMethodCode
        });
      });
    });
  }
}
